import { createContext, useState } from "react";
import { useDispatch } from "react-redux";
import { isEmpty } from "lodash";

import {
  createRecruitmentItemService,
  deleteRecruitmentItemService,
  editRecruitmentItemService,
  getCategoryItemsService,
  getRecruitmentItemsService,
  getServicesService,
} from "./../../../services/userServices";
import {
  setLoadingFalseAction,
  setLoadingTrueAction,
} from "./../../../redux/actions/loadingActions/loadingActions";
import {
  toastErrorMessage,
  toastSuccessMessage,
} from "../../../utils/toastMessage/toastMessage";

export const recruitmentAdminContext = createContext({
  categories: [],
  setCategories: () => {},
  recruitmentItems: [],
  setRecruitmentItems: () => {},
  recruitment: {},
  setRecruitment: () => {},
  services: [],
  setServices: () => {},
  id: "",
  setId: () => {},
  search: "",
  setSearch: () => {},
  appearance_search: null,
  setAppearance_search: () => {},
  education_search: null,
  setEducation_search: () => {},
  speech_style_search: null,
  setSpeech_style_search: () => {},
  impression_search: null,
  setImpression_search: () => {},
  referral_source_search: null,
  setReferral_source_search: () => {},
  final_result_search: null,
  setFinal_result_search: () => {},
  preliminary_result_search: null,
  setPreliminary_result_search: () => {},
  isShowModal: null,
  setIsShowModal: () => {},
  isShowDetailsModal: null,
  setIsShowDetailsModal: () => {},
  totalCount: null,
  setTotalCount: () => {},
  pageNumber: null,
  setPageNumber: () => {},
  isShowAdvancedSearch: null,
  setIsShowAdvancedSearch: () => {},
  limit: null,
  setLimit: () => {},
  sort_by: "",
  setSort_by: () => {},
  handleShowModal: () => {},
  handleCloseModal: () => {},
  handleShowDetailsModal: () => {},
  handleCloseDetailsModal: () => {},
  handleGetCategories: () => {},
  handleGetServices: () => {},
  handleGetRecruitmentItemList: () => {},
  handleCreateRecruitmentItem: () => {},
  handleEditRecruitmentItem: () => {},
  handleDeleteRecruitmentItem: () => {},
  isSelectExpertise: () => {},
});

const RecruitmentAdminContext = ({ children }) => {
  // Redux Dispatch
  const dispatch = useDispatch();

  const [categories, setCategories] = useState([]);
  const [recruitmentItems, setRecruitmentItems] = useState([]);
  const [recruitment, setRecruitment] = useState({});
  const [services, setServices] = useState([]);
  const [id, setId] = useState("");
  const [expertiseSearch, setExpertiseSearch] = useState("");
  const [referral_source, setReferral_source] = useState(null);
  const [final_result, setFinal_result] = useState(null);
  const [preliminary_result, setPreliminary_result] = useState(null);
  const [referral_source_search, setReferral_source_search] = useState(null);
  const [final_result_search, setFinal_result_search] = useState(null);
  const [preliminary_result_search, setPreliminary_result_search] =
    useState(null);
  const [attendance_date, setAttendance_date] = useState("");
  const [recruitment_date, setRecruitment_date] = useState("");
  const [mobile, setMobile] = useState("");
  const [first_name, setFirst_name] = useState("");
  const [last_name, setLast_name] = useState("");
  const [sort_by, setSort_by] = useState("-created");
  const [search, setSearch] = useState("");
  const [expertise, setExpertise] = useState([]);
  const [appearance, setAppearance] = useState(false);
  const [education, setEducation] = useState(false);
  const [speech_style, setSpeech_style] = useState(false);
  const [impression, setImpression] = useState(false);
  const [appearance_search, setAppearance_search] = useState("");
  const [education_search, setEducation_search] = useState("");
  const [speech_style_search, setSpeech_style_search] = useState("");
  const [impression_search, setImpression_search] = useState("");
  const [description, setDescription] = useState("");
  const [isShowModal, setIsShowModal] = useState(false);
  const [isShowDetailsModal, setIsShowDetailsModal] = useState(false);
  const [isShowAdvancedSearch, setIsShowAdvancedSearch] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [pageNumber, setPageNumber] = useState(1);
  const [limit, setLimit] = useState(100);

  const handleResetState = () => {
    setId("");
    setExpertiseSearch("");
    setReferral_source(null);
    setFinal_result(null);
    setPreliminary_result(null);
    setReferral_source_search(null);
    setFinal_result_search(null);
    setPreliminary_result_search(null);
    setAttendance_date("");
    setRecruitment_date("");
    setMobile("");
    setFirst_name("");
    setLast_name("");
    setSearch("");
    setExpertise([]);
    setAppearance(false);
    setEducation(false);
    setSpeech_style(false);
    setImpression(false);
    setAppearance_search("");
    setEducation_search("");
    setSpeech_style_search("");
    setImpression_search("");
    setDescription("");
  };

  // Create User Satisfaction Modal Operations
  const handleShowModal = (itemValue) => {
    setIsShowModal(true);
    if (itemValue) {
      setId(itemValue.id);
      setReferral_source(itemValue.referral_source);
      setFinal_result(itemValue.final_result);
      setPreliminary_result(itemValue.preliminary_result);
      setAttendance_date(itemValue.attendance_date);
      setRecruitment_date(itemValue.recruitment_date);
      // setMobile(itemValue?.user?.mobile);
      // setFirst_name(itemValue?.user?.first_name);
      // setLast_name(itemValue?.user?.last_name);
      setExpertise(itemValue?.services?.map((s) => s.id));
      setAppearance(itemValue.appearance);
      setEducation(itemValue.education);
      setSpeech_style(itemValue.speech_style);
      setImpression(itemValue.impression);
      setDescription(itemValue.description);
    }
  };
  const handleCloseModal = () => {
    setIsShowModal(false);
    handleResetState();
  };

  // Details User Satisfaction Modal Operations
  const handleShowDetailsModal = (value) => {
    setIsShowDetailsModal(true);
    setRecruitment(value);
  };
  const handleCloseDetailsModal = () => {
    setIsShowDetailsModal(false);
    setRecruitment({});
  };

  // Handle Get Categories Method
  const handleGetCategories = async (event) => {
    event?.preventDefault();

    try {
      const { status, data } = await getCategoryItemsService();
      if (status === 200) {
        setCategories(data.results);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    }
  };

  // Handle Get Services Method
  const handleGetServices = async (categoryId) => {
    const objData = { service_category_id: categoryId, offset: 0, limit: 300 };

    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getServicesService(objData);
      if (status === 200) {
        setServices(data.list);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Get User Satisfaction Item List Method
  const handleGetRecruitmentItemList = async (event) => {
    event?.preventDefault();
    const isSearch = !isEmpty(event);

    const objData = {
      ...(search && { search }),
      offset: ((isSearch ? 1 : pageNumber) - 1) * limit,
      limit,
      sort_by,
      ...(referral_source_search && {
        referral_source: referral_source_search,
      }),
      ...(final_result_search && { final_result: final_result_search }),
      ...(preliminary_result_search && {
        preliminary_result: preliminary_result_search,
      }),
      ...(appearance_search && {
        appearance: appearance_search === "true",
      }),
      ...(education_search && {
        education: education_search === "true",
      }),
      ...(speech_style_search && {
        speech_style: speech_style_search === "true",
      }),
      ...(impression_search && {
        impression: impression_search === "true",
      }),
    };
    try {
      dispatch(setLoadingTrueAction());
      const { status, data } = await getRecruitmentItemsService(objData);
      if (status === 200) {
        setRecruitmentItems(data.results);
        setTotalCount(data.count);
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
    } finally {
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Create User Satisfaction Item Method
  const handleCreateRecruitmentItem = async (event) => {
    event?.preventDefault();

    let attendance_dateVal = null;
    let recruitment_dateVal = null;
    if (!!attendance_date) {
      attendance_dateVal = new Date(attendance_date);
      attendance_dateVal = attendance_dateVal?.toISOString()?.split("T")[0];
    }
    if (!!recruitment_date) {
      recruitment_dateVal = new Date(recruitment_date);
      recruitment_dateVal = recruitment_dateVal.toISOString().split("T")[0];
    }

    const objData = {
      id,
      referral_source,
      final_result,
      preliminary_result,
      ...(!!attendance_dateVal && {
        attendance_date: `${attendance_dateVal} 23:59:59`,
      }),
      ...(!!recruitment_dateVal && {
        recruitment_date: `${recruitment_dateVal} 23:59:59`,
      }),
      mobile,
      first_name,
      last_name,
      services: expertise,
      appearance,
      education,
      speech_style,
      impression,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await createRecruitmentItemService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ایجاد شد");
        handleGetRecruitmentItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Edit User Satisfaction Item Method
  const handleEditRecruitmentItem = async (event) => {
    event?.preventDefault();

    let attendance_dateVal = null;
    let recruitment_dateVal = null;
    if (!!attendance_date) {
      attendance_dateVal = new Date(attendance_date);
      attendance_dateVal = attendance_dateVal?.toISOString()?.split("T")[0];
    }
    if (!!recruitment_date) {
      recruitment_dateVal = new Date(recruitment_date);
      recruitment_dateVal = recruitment_dateVal.toISOString().split("T")[0];
    }
    const objData = {
      id,
      referral_source,
      final_result,
      preliminary_result,
      ...(!!attendance_dateVal && {
        attendance_date: `${attendance_dateVal} 23:59:59`,
      }),
      ...(!!recruitment_dateVal && {
        recruitment_date: `${recruitment_dateVal} 23:59:59`,
      }),
      mobile,
      first_name,
      last_name,
      services: expertise,
      appearance,
      education,
      speech_style,
      impression,
      description,
    };

    try {
      dispatch(setLoadingTrueAction());
      const { status } = await editRecruitmentItemService(objData);
      if (status === 200) {
        toastSuccessMessage("آیتم با موفقیت ویرایش شد");
        handleGetRecruitmentItemList();
        handleCloseModal();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Handle Delete User Satisfaction Item Method
  const handleDeleteRecruitmentItem = async (id) => {
    try {
      dispatch(setLoadingTrueAction());
      const { status } = await deleteRecruitmentItemService(id);
      if (status === 204) {
        toastSuccessMessage(`آیتم  ${id} با موفقیت حذف شد`);
        handleGetRecruitmentItemList();
      }
    } catch ({ response }) {
      if (response?.status) {
        toastErrorMessage();
      }
      dispatch(setLoadingFalseAction());
    }
  };

  // Expertise Methods
  const isSelectExpertise = (ui) => {
    return expertise?.find((s) => s === ui);
  };

  return (
    <recruitmentAdminContext.Provider
      value={{
        categories,
        setCategories,
        recruitmentItems,
        setRecruitmentItems,
        recruitment,
        setRecruitment,
        services,
        setServices,
        totalCount,
        setTotalCount,
        pageNumber,
        setPageNumber,
        limit,
        setLimit,
        sort_by,
        setSort_by,
        id,
        setId,
        expertiseSearch,
        setExpertiseSearch,
        referral_source,
        setReferral_source,
        final_result,
        setFinal_result,
        preliminary_result,
        setPreliminary_result,
        referral_source_search,
        setReferral_source_search,
        final_result_search,
        setFinal_result_search,
        preliminary_result_search,
        setPreliminary_result_search,
        attendance_date,
        setAttendance_date,
        recruitment_date,
        setRecruitment_date,
        mobile,
        setMobile,
        first_name,
        setFirst_name,
        last_name,
        setLast_name,
        expertise,
        setExpertise,
        appearance,
        setAppearance,
        education,
        setEducation,
        speech_style,
        setSpeech_style,
        appearance_search,
        setAppearance_search,
        education_search,
        setEducation_search,
        speech_style_search,
        setSpeech_style_search,
        impression_search,
        setImpression_search,
        impression,
        setImpression,
        description,
        setDescription,
        isShowModal,
        setIsShowModal,
        isShowDetailsModal,
        setIsShowDetailsModal,
        isShowAdvancedSearch,
        setIsShowAdvancedSearch,
        handleShowDetailsModal,
        handleCloseDetailsModal,
        handleShowModal,
        handleCloseModal,
        handleGetCategories,
        handleGetServices,
        handleGetRecruitmentItemList,
        handleCreateRecruitmentItem,
        handleEditRecruitmentItem,
        handleDeleteRecruitmentItem,
        isSelectExpertise,
      }}
    >
      {children}
    </recruitmentAdminContext.Provider>
  );
};

export default RecruitmentAdminContext;
